module.exports = __webpack_public_path__ + "static/media/introduction1.28bc8b6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/introduction1.jpg
// module id = 19
// module chunks = 0